(function () {
  var FIELD_LABELS = {
    chest: 'Chest',
    bust: 'Bust',
    overbust: 'Over Bust',
    underbust: 'Under Bust',
    waist: 'Waist',
    hip: 'Hip',
  };

  function parseRangeMax(raw) {
    var str = String(raw);
    if (str.indexOf('-') !== -1) {
      var parts = str.split('-');
      return parseFloat(parts[1]);
    }
    return parseFloat(str);
  }

  function findStyleEntry(handle) {
    var data = window.FMS_DATA || {};
    for (var styleCode in data) {
      if (!Object.prototype.hasOwnProperty.call(data, styleCode)) continue;
      var entry = data[styleCode];
      if (entry.handles && entry.handles.indexOf(handle) !== -1) return entry;
    }
    return null;
  }

  function pickSizeIndexForField(sizes, field, value) {
    for (var i = 0; i < sizes.length; i++) {
      var raw = sizes[i][field];
      if (raw === undefined) continue;
      if (value <= parseRangeMax(raw)) return i;
    }
    return sizes.length - 1;
  }

  function recommend(entry, inputs) {
    var bestIdx = -1;
    for (var i = 0; i < entry.askFor.length; i++) {
      var field = entry.askFor[i];
      var val = inputs[field];
      if (!val) continue;
      var idx = pickSizeIndexForField(entry.sizes, field, parseFloat(val));
      if (idx > bestIdx) bestIdx = idx;
    }
    if (bestIdx === -1) return null;
    return entry.sizes[bestIdx].size;
  }

  function buildWidget(container, entry) {
    var wrap = document.createElement('div');
    wrap.className = 'find-my-size';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'find-my-size__toggle link';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Find My Size';
    wrap.appendChild(toggle);

    var panel = document.createElement('div');
    panel.className = 'find-my-size__panel';
    panel.hidden = true;

    var hint = document.createElement('p');
    hint.className = 'find-my-size__hint';
    hint.textContent = 'Enter your measurements in inches';
    panel.appendChild(hint);

    var fieldsWrap = document.createElement('div');
    fieldsWrap.className = 'find-my-size__fields';
    entry.askFor.forEach(function (field) {
      var label = document.createElement('label');
      label.className = 'find-my-size__field';

      var span = document.createElement('span');
      span.textContent = (FIELD_LABELS[field] || field) + ' (in)';
      label.appendChild(span);

      var input = document.createElement('input');
      input.type = 'number';
      input.step = '0.1';
      input.min = '0';
      input.inputMode = 'decimal';
      input.setAttribute('data-field', field);
      input.addEventListener('input', function () {
        input.classList.toggle('find-my-size__input--filled', !!input.value);
        updateSubmitState();
      });
      label.appendChild(input);

      fieldsWrap.appendChild(label);
    });
    panel.appendChild(fieldsWrap);

    var submitBtn = document.createElement('button');
    submitBtn.type = 'button';
    submitBtn.className = 'find-my-size__submit';
    submitBtn.textContent = 'Get My Size';
    panel.appendChild(submitBtn);

    function updateSubmitState() {
      var anyFilled = Array.prototype.some.call(
        fieldsWrap.querySelectorAll('[data-field]'),
        function (inp) { return !!inp.value; }
      );
      submitBtn.classList.toggle('find-my-size__submit--active', anyFilled);
    }

    var resultEl = document.createElement('div');
    resultEl.className = 'find-my-size__result';
    resultEl.hidden = true;
    resultEl.setAttribute('role', 'status');
    panel.appendChild(resultEl);

    wrap.appendChild(panel);

    toggle.addEventListener('click', function () {
      var willShow = panel.hidden;
      panel.hidden = !willShow;
      toggle.setAttribute('aria-expanded', String(willShow));
    });

    submitBtn.addEventListener('click', function () {
      var inputs = {};
      var hasAny = false;
      fieldsWrap.querySelectorAll('[data-field]').forEach(function (inp) {
        if (inp.value) {
          inputs[inp.getAttribute('data-field')] = inp.value;
          hasAny = true;
        }
      });
      resultEl.hidden = false;
      if (!hasAny) {
        resultEl.textContent = 'Please enter at least one measurement.';
        return;
      }
      var size = recommend(entry, inputs);
      resultEl.textContent = size
        ? 'Recommended size: ' + size
        : "Couldn't determine a size — please check the size chart.";
    });

    container.appendChild(wrap);
  }

  function init(container) {
    var handle = container.getAttribute('data-product-handle');
    var entry = findStyleEntry(handle);
    if (!entry || !entry.askFor || !entry.askFor.length || !entry.sizes || !entry.sizes.length) return;
    buildWidget(container, entry);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.find-my-size-root').forEach(init);
  });
})();
